/* 
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */

angular.module('common.filter.description',['pascalprecht.translate', 'common.helper']).filter('description', function($translate, CommonHelper){
    return function(descriptions, language) {
        if (!descriptions){
            return null;
        }

        var descriptionFound = null;
        if (language){

            //First, find the description of the given language parameter.
            descriptionFound = descriptions[language];
        }

        if (!descriptionFound){

            //Find the description of the language being used.
            descriptionFound = descriptions[CommonHelper.getLanguageCode($translate.use())];
        }

        if (!descriptionFound){

            //If there is no description for the language being used, find the English description
            descriptionFound =  descriptions.en;
        }
        if (!descriptionFound){

            //If there is not English description, use the first description from the description map.
            for (var lang in descriptions) {
                descriptionFound = descriptions[lang];
                break;
            }
        }

        return descriptionFound;
  };
});



// WEBPACK FOOTER //
// ./app/common/filter/description-filter.js